import styled from 'styled-components';

export const NoDataWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 122px);
`;

export const Content = styled.div`
  width: 700px;
`;

export const Title = styled.div`
  color: #717171;
  font-family: Lato;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 25.2px;
  margin-bottom: 16px;
`;

export const Description = styled.div`
  color: var(--Grayscale-tertiaryGrey, #717171);
  font-family: Lato;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 18.2px;
`;

export const List = styled.ul`
  color: #717171;
  font-family: Lato;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 18.2px;
  padding-left: 15px;
`;
